import { IAM } from '../apis.js';
const reqIAM = IAM('/me', false);
export const get = () => reqIAM('GET', `/`);
export const update = (data) => reqIAM('PATCH', `/`, {
    body: data,
});
//# sourceMappingURL=me.js.map